// extracted by mini-css-extract-plugin
export default {"zoomControls":"qaa-z","zoomControlButton":"raa-z","zoomBanner":"saa-z","bannerButton":"taa-z","imageButton":"uaa-z","zoom":"vaa-z","zoomContent":"waa-z"};